module.exports = __webpack_public_path__ + "img/02-egg-3-base.b08bc84a.svg";